
import { motion } from "framer-motion";
import { useTranslation } from 'react-i18next';

export const OverviewSection = () => {
  const { t } = useTranslation();
  return (
    <>
      <motion.section
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="text-2xl font-bold mb-4 mt-8 text-white">{t('plans_detail.safety_net.overview.title')}</h2>
        <p className="mb-4 text-white/70 leading-relaxed">
          {t('plans_detail.safety_net.overview.body1')}
        </p>
        <p className="mb-8 text-white/70 leading-relaxed">
          {t('plans_detail.safety_net.overview.body2')}
        </p>
      </motion.section>

      <motion.section
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="text-2xl font-bold mb-4 text-white">{t('plans_detail.safety_net.eligible.title')}</h2>
        <p className="mb-4 text-white/70 leading-relaxed">
          {t('plans_detail.safety_net.eligible.intro')}
        </p>

        <motion.div
          className="space-y-4 mb-8"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={{ hidden: {}, visible: { transition: { staggerChildren: 0.08 } } }}
        >
          <motion.div
            variants={{ hidden: { opacity: 0, y: 16 }, visible: { opacity: 1, y: 0, transition: { duration: 0.4 } } }}
            whileHover={{ scale: 1.02 }}
            className="border border-white/10 bg-white/5 p-6 rounded-xl"
          >
            <h3 className="font-bold text-lg mb-2 text-white">{t('plans_detail.safety_net.eligible.crit1_title')}</h3>
            <ul className="list-disc pl-6 space-y-2 text-white/70">
              <li>{t('plans_detail.safety_net.eligible.crit1_item1')}</li>
              <li>{t('plans_detail.safety_net.eligible.crit1_item2')}</li>
              <li>{t('plans_detail.safety_net.eligible.crit1_item3')}</li>
              <li>{t('plans_detail.safety_net.eligible.crit1_item4')}</li>
            </ul>
          </motion.div>

          <motion.div
            variants={{ hidden: { opacity: 0, y: 16 }, visible: { opacity: 1, y: 0, transition: { duration: 0.4 } } }}
            whileHover={{ scale: 1.02 }}
            className="border border-white/10 bg-white/5 p-6 rounded-xl"
          >
            <h3 className="font-bold text-lg mb-2 text-white">{t('plans_detail.safety_net.eligible.crit2_title')}</h3>
            <p className="text-white/70">{t('plans_detail.safety_net.eligible.crit2_body')}</p>
          </motion.div>
        </motion.div>
      </motion.section>
    </>
  );
};
